import { LocalizedForm } from "common/localization";

export default class NakiNigunAlbumEditForm extends LocalizedForm {
    setup() {
        return {
            fields: [
                {
                    name: "title",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.TITLE_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.TITLE_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "isActive",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_ACTIVE_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_ACTIVE_PLACEHOLDER",
                    type: "checkbox",
                    value: false,
                },
                {
                    name: "scheduledReleaseAt",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.SCHEDULED_RELEASE_AT_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.SCHEDULED_RELEASE_AT_PLACEHOLDER",
                    type: "text",
                    value: "",
                },
                {
                    name: "isPremium",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_PREMIUM_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_PREMIUM_PLACEHOLDER",
                    type: "checkbox",
                },
                {
                    name: "isTurnedOnByDefault",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_LABEL",
                    placeholder:
                        "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_PLACEHOLDER",
                    type: "checkbox",
                    value: true,
                },
                {
                    name: "isTurnedOnByDefaultInApp",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_APP_LABEL",
                    placeholder:
                        "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_APP_PLACEHOLDER",
                    type: "checkbox",
                    value: true,
                },
                {
                    name: "isTurnedOnByDefaultInEmbeddedApp",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_EMBEDDED_APP_LABEL",
                    placeholder:
                        "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_EMBEDDED_APP_PLACEHOLDER",
                    type: "checkbox",
                    value: true,
                },
                {
                    name: "isTurnedOnByDefaultInHandheldPinkApp",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_HANDHELD_PINK_APP_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_HANDHELD_PINK_APP_PLACEHOLDER",
                    type: "checkbox",
                    value: true,
                },
                {
                    name: "isTurnedOnByDefaultInHandheldApp",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_HANDHELD_APP_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_TURNED_ON_BY_DEFAULT_IN_HANDHELD_APP_PLACEHOLDER",
                    type: "checkbox",
                    value: true,
                },
                {
                    name: "overrideRadioUsersSettings",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELD.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    type: "checkbox",
                },
                {
                    name: "overrideAppUsersSettings",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELD.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    type: "checkbox",
                },
                {
                    name: "overrideHandheldPinkUsersSettings",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    type: "checkbox",
                },
                {
                    name: "overrideHandheldUsersSettings",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_OVERRIDE_USERS_SETTINGS",
                    type: "checkbox",
                },
                {
                    name: "isFeatured",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_FEATURED_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_FEATURED_PLACEHOLDER",
                    type: "checkbox",
                },
                {
                    name: "genreIds",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.GENRE_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.GENRE_PLACEHOLDER",
                },
                {
                    name: "keywords",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.KEYWORDS_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.KEYWORDS_PLACEHOLDER",
                    rules: "string",
                },
                {
                    // The whole release date, held as the API's own `YYYY-MM-DDT00:00:00` string.
                    // A calendar is the only writer, so there is no cross-field rule to enforce and
                    // no impossible date to guard against.
                    name: "releaseDate",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.RELEASE_DATE_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.RELEASE_DATE_PLACEHOLDER",
                    type: "text",
                    value: "",
                },
                {
                    name: "price",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.PRICE_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.PRICE_PLACEHOLDER",
                    rules: "numeric|min:0",
                },
                {
                    name: "albumFeed",
                    fields: [
                        {
                            name: "feedUrl",
                            label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.FEED_URL_LABEL",
                            placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.FEED_URL_PLACEHOLDER",
                            rules: "string",
                        },
                        {
                            name: "contentSortTypeId",
                            label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.CONTENT_SORT_TYPE_LABEL",
                            placeholder:
                                "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.CONTENT_SORT_TYPE_PLACEHOLDER",
                            type: "required|string",
                        },
                        {
                            name: "hlsEnabled",
                            label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.EDIT.ALBUM.FIELDS.IS_HLS_ENABLED_LABEL",
                            placeholder: "",
                            type: "checkbox",
                        },
                    ],
                },
            ],
        };
    }
}
